var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.tagNav[1])?_c('homeView',{attrs:{"list":_vm.list,"child":_vm.tagNav[1].child.slice(0,3)}}):_vm._e(),_c('homeView2',{attrs:{"list":_vm.tagLink}}),_c('footerView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }